// Dummy reviews for Ganesha and Hanuman products
export const dummyReviews = {
  ganesha: [
    {
      star: 5,
      comment: "My son absolutely loved this cute Ganesha soft toy. The quality is really good – soft, well-stitched, and safe for kids to play with. The colors are bright and exactly as shown in the pictures. It’s cuddly, lightweight, and makes a perfect gift for little ones. Very happy with this purchase! 🙏✨",
      postedby: {
        firstname: "Sapana",
        lastname: "Singh"
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766051759/ftvwhra7ab4hugozfycm.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766051776/ezq6301kp0yp71qbamus.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766051792/mzaq39muapk4qkani6ph.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766051803/c427sz2pldpf9l4a8lrc.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766051819/vvpcizpeostneu4blcjn.jpg"
        }
      ],
      createdAt: "2025-09-15T10:30:00Z"
    },
    {
      star: 5,
      comment: "Delivery was quick, amazing product overall. Would highly recommend to buy veda products. Ordered it for my nephew and he loved the toy.",
      postedby: {
        firstname: "Maulik",
        lastname: "Patel"
      },
      images: [
      ],
      createdAt: "2025-02-17T14:15:00Z"
    },
    {
      star: 5,
      comment: "I got this for my 6 month old Niece. There isn't much difference between the two. Both are equally cute and cuddly to hold. The depiction of Lord Ganesha is very accurate, including the broken tusk, although my niece is more focussed on chewing the ears and trying to pull out the trunk.Rest assured, this product can withstand all of this and still remain cute. Good stuff!!",
      postedby: {
        firstname: "Shray",
        lastname: "desai"
      },
      images: [
      ],
      createdAt: "2025-03-14T09:45:00Z"
    },
    {
      star: 5,
      comment: "This Ganesha toy is an ideal gift for children and a beautiful addition to home decor.",
      postedby: {
        firstname: "Rini",
        lastname: ""
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784902/hiwormyeamq5u1pcce6w.jpg"
        }
      ],
      createdAt: "2025-01-29T16:20:00Z"
    },
    {
      star: 5,
      comment: "Good product",
      postedby: {
        firstname: "Utkarsh",
        lastname: ""
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784908/qklqiwpylpvpowjtmmrf.jpg"
        }
      ],
      createdAt: "2025-01-04T11:30:00Z"
    }
  ],
  hanuman: [
    {
      star: 5,
      comment: "I gifted my 7-year-old son Veda’s Bal Hanuman plush, and it has truly been a wonderful find. The quality is excellent, with thoughtful detailing and a beautifully crafted design. What really stands out is how unique it is — so different from the usual products available in India. It’s a lovely and engaging way to introduce our Gods and cultural stories to children at a very young age, in a form that feels fun, safe, and meaningful. Truly a special gift that blends tradition with modern sensibility.",
      postedby: {
        firstname: "Parth",
        lastname: "T."
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784143/sbrfqipehx07c94wlk80.jpg"
        }
      ],
      createdAt: "2025-12-21T13:45:00Z"
    },
    {
      star: 5,
      comment: "Excellent quality and sturdy build. Perfect for display in our temple room.",
      postedby: {
        firstname: "Deepa",
        lastname: "Nair"
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784146/ayy6zfafvauxrkdewpu4.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784149/puxlkhvmzarykjkwe3dx.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784152/qyrrsswhvo7pdlysuyvg.jpg"
        }
      ],
      createdAt: "2024-02-18T15:30:00Z"
    },
    {
      star: 5,
      comment: "The devotion put into crafting this piece is evident. It brings peace and positivity to our home.",
      postedby: {
        firstname: "Arjun",
        lastname: "Malhotra"
      },
      images: [
          {
            url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1765784176/lifpoh8r7ewkhudqd4b2.jpg"
          }
      ],
      createdAt: "2024-03-25T10:15:00Z"
    },
    {
      star: 5,
      comment: "I gifted my 2yr old daughter Veda's Bal Hanuman and it is undoubtedly the best gift. I was looking for high quality God figures and finally I found it with Veda. It is such a good way to introduce our Gods and cultural stories in their lives in a fun way at an early age.",
      postedby: {
        firstname: "Priya",
        lastname: "Sharma"
      },
      images: [
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766651980/qufb2chbsfm7znxtc5ip.jpg"
        },
        {
          url: "https://res.cloudinary.com/khushitiwaricloudinary/image/upload/v1766651981/mcxjklagmyfiqn4amhqo.jpg"
        }
      ],
      createdAt: "2025-12-20T10:30:00Z"
    },
    {
      star: 5,
      comment: "Great gift option for my sister. She loved it and is obsessed with the toy. No regrets in buying the product. Absolutely worth the money.",
      postedby: {
        firstname: "Chaitya",
        lastname: "Shah"
      },
      images: [
      ],
      createdAt: "2025-12-21T10:30:00Z"
    }
  ]
};

// Function to calculate average rating
export const calculateAverageRating = (reviews) => {
  if (!reviews || reviews.length === 0) return 0;
  
  const totalStars = reviews.reduce((sum, review) => sum + review.star, 0);
  return Math.round((totalStars / reviews.length) * 10) / 10; // Round to 1 decimal place
};